/*
 *   Copyright (c) 2021 Novumare Technologies
 *   All rights reserved.
 */
import React from "react";
import { useTranslation } from "react-i18next";

export default function FooterSmall(props) {
  const { t } = useTranslation();
  return (
    <>
      <footer
        className={
          (props.absolute
            ? "absolute w-full bottom-0 bg-gray-900"
            : "relative") + " pb-6"
        }
      >
        <div className="container mx-auto px-4">
          <hr className="mb-6 border-b-1 border-gray-700" />
          <div className="flex flex-wrap items-center md:justify-between justify-center">
            <div className="w-full md:w-4/12 px-4">
              <div className="text-sm text-gray-600 font-semibold py-1 text-center md:text-left">
                Copyright © {new Date().getFullYear()}{" "}
                <a
                  href="https://novumare.com.tr/"
                  className="text-white hover:text-gray-400 text-sm font-semibold py-1"
                >
                  Novumare Technologies
                </a>
              </div>
            </div>
            <div className="w-full md:w-8/12 px-4">
              <ul className="flex flex-wrap list-none md:justify-end  justify-center">
                <li>
                  <a
                    href="https://www.creative-tim.com?ref=nr-footer-small"
                    className="text-white hover:text-gray-400 text-sm font-semibold block py-1 px-3"
                  >
                    {t('help')}
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.creative-tim.com/presentation?ref=nr-footer-small"
                    className="text-white hover:text-gray-400 text-sm font-semibold block py-1 px-3"
                  >
                    {t('features')}
                  </a>
                </li>
                <li>
                  <a
                    href="http://blog.creative-tim.com?ref=nr-footer-small"
                    className="text-white hover:text-gray-400 text-sm font-semibold block py-1 px-3"
                    // onClick={() => void (Tawk_API.maximize())}
                  >
                    {t('pricing')}
                  </a>
                </li>
                <li>
                  <a
                    href="https://novumare.com.tr/"
                    className="text-white hover:text-gray-400 text-sm font-semibold block py-1 px-3"
                  >
                    {t('about')}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
